import type { RootState } from "@/app/store";
import { MarcaProduto } from "@/contexts/laboratorio/marcaProduto/model/MarcaProduto";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MarcaProdutoState {
  items: MarcaProduto[];
  synced: boolean;
}

const initialState: MarcaProdutoState = {
  items: [],
  synced: false,
};

const marcaProdutoSlice = createSlice({
  name: "MARCA_PRODUTO",
  initialState,
  reducers: {
    sync: {
      reducer: (state, action: PayloadAction<{ items: MarcaProduto[] }>) => {
        state.items = action.payload.items;
        state.synced = true;
      },
      prepare: (items: MarcaProduto[]) => ({
        payload: { items },
      }),
    },
  },
});

export const marcaProdutoAction = marcaProdutoSlice.actions;

export default marcaProdutoSlice.reducer;

export const getMarcaProdutoSynced = (state: RootState) =>
  state.marcaProduto.items;
